import React from 'react';

const DashboardIcon = () => {
  return (
    <svg
      width='11'
      height='12'
      viewBox='0 0 11 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.33333 10.3333H3.33333V7C3.33333 6.81111 3.39733 6.65289 3.52533 6.52533C3.65333 6.39778 3.81156 6.33378 4 6.33333H6.66667C6.85556 6.33333 7.014 6.39733 7.142 6.52533C7.27 6.65333 7.33378 6.81156 7.33333 7V10.3333H9.33333V4.33333L5.33333 1.33333L1.33333 4.33333V10.3333ZM0 10.3333V4.33333C0 4.12222 0.0473332 3.92222 0.142 3.73333C0.236667 3.54444 0.367111 3.38889 0.533333 3.26667L4.53333 0.266667C4.76667 0.0888889 5.03333 0 5.33333 0C5.63333 0 5.9 0.0888889 6.13333 0.266667L10.1333 3.26667C10.3 3.38889 10.4307 3.54444 10.5253 3.73333C10.62 3.92222 10.6671 4.12222 10.6667 4.33333V10.3333C10.6667 10.7 10.536 11.014 10.2747 11.2753C10.0133 11.5367 9.69956 11.6671 9.33333 11.6667H6.66667C6.47778 11.6667 6.31956 11.6027 6.192 11.4747C6.06444 11.3467 6.00044 11.1884 6 11V7.66667H4.66667V11C4.66667 11.1889 4.60267 11.3473 4.47467 11.4753C4.34667 11.6033 4.18844 11.6671 4 11.6667H1.33333C0.966667 11.6667 0.652889 11.5362 0.392 11.2753C0.131111 11.0144 0.000444444 10.7004 0 10.3333Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default DashboardIcon;
